type Props = { k: string };

export const Kbd = ({ k }: Props) => <span className="tp-kbd">{k}</span>;
